import { createEvent, sample } from 'effector'
import { EditWalletTransaction } from './types'
import { fx } from 'src/libs'

const buildBody = (data: EditWalletTransaction) => ({
  type: data.type,
  wallet: data.wallet,
  amount: data.amount,
  currency: data.currency,
  ourCommission: data.ourCommission,
  ourCommissionCurrency: data.ourCommissionCurrency,
})

export const editWalletTransactionMounted = createEvent<EditWalletTransaction>()

export const editWalletTransaction = fx<ReturnType<typeof buildBody>, void>({
  method: 'PUT',
  url: '/finance/wallet-client-transaction/{transaction_id}',
})

sample({
  clock: editWalletTransactionMounted,
  fn: (data) => ({
    url: `/finance/wallet-client-transaction/${data.transactionId}`,
    body: buildBody(data),
  }),
  target: editWalletTransaction,
})
